function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { SearchConsumer } from './SearchContext';
const withSearchConsumer = (mapSearchToProps = {}) => WrappedComponent => hoistNonReactStatics( /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SearchConsumer, null, ({
  searchAdapter,
  searchResult
}) => {
  const injectedProps = Object.keys(mapSearchToProps).reduce((accum, prop) => ({
    ...accum,
    [prop]: mapSearchToProps[prop](searchAdapter, props)
  }), {});
  return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
    ref: ref,
    searchAdapter: searchAdapter,
    searchResult: searchResult
  }, injectedProps));
})), WrappedComponent);
export default withSearchConsumer;